<template>
    <div>
        <h3>{{method}} {{path}}</h3>
        <p>{{info}}<p>
        <div v-if="method == 'POST' || method == 'PUT' || method == 'PATCH'">
            <b /><br />Request payload:
            <code-box v-if="hasRequest"><slot name="request"></slot></code-box>
            <code-box v-else><slot name="request">// N/A</slot></code-box>
            {{requestInfo}}
        </div>
        <div>
            <b /><br />Response body:
            <code-box v-if="hasResponse"><slot name="response"></slot></code-box>
            <code-box v-else><slot name="response">// N/A, i.e. status 204 No Content</slot></code-box>
            {{responseInfo}}
        </div>
        <dm-divider></dm-divider>
    </div>
</template>

<script>
import CodeBox from '@/components/CodeBox.vue'

export default {
    name: 'ApiCommand',
    props: {
        method: String,
        path: String,
        requestInfo: String,
        responseInfo: String,
        info: String
    },
    components: {
        CodeBox
    },
    computed: {
        hasResponse() {
            return this.$slots.response
        },
        hasRequest() {
            return this.$slots.request
        }
    }
}
</script>

<style scoped>

</style>
